import { createMachine, sendParent } from 'xstate';

import { Context } from './types';

export const createToastMachine = (
  messageId: string,
  hideAfterTimeMs: number
) =>
  createMachine(
    {
      predictableActionArguments: true,
      context: {
        messageId,
      },
      initial: 'visible',
      states: {
        visible: {
          after: {
            HIDE_DELAY: { target: 'exit' },
          },
        },
        exit: {
          entry: [
            sendParent((ctx: Context) => ({
              type: 'HIDE_TOAST',
              messageId: ctx.messageId,
            })),
          ],
        },
      },
    },
    {
      delays: {
        HIDE_DELAY: hideAfterTimeMs,
      },
    }
  );
